export default __webpack_public_path__ + "static/media/NicolasRegnier.c0631672.png";